import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/sales-management/returns-list`;

export const returnsListRoutesObj = {
  list: baseRoute,
  restoreGoods: `${baseRoute}/restore-goods/:invoiceId/:returnId`,
} as const;

export type IReturnsListRouteParams = IExtractRouteParamMap<
  typeof returnsListRoutesObj
>;

export const returnsListPath = createPaths<
  typeof returnsListRoutesObj,
  IReturnsListRouteParams
>(returnsListRoutesObj);
